import { getEnv } from '@/lib/env'

/**
 * Ruta de la pantalla de la trivia dentro de `comunidad-web` (la fijó el goal
 * trivias-de-la-comunidad 3: `AppRoutes.tsx`, `/trivia`). Vive aquí, en una
 * sola constante, para que el día que cambie se cambie en un sitio.
 */
export const RUTA_TRIVIA = '/trivia'

/**
 * URL absoluta de la trivia semanal, compuesta sobre `VITE_COMUNIDAD_URL`.
 *
 * Devuelve `undefined` cuando la env no está configurada, y ese es el punto:
 * sin comunidad a la que ir **no se pinta el acceso** — el mismo
 * comportamiento que la sección pública `Comunidad.tsx`, que se oculta entera
 * (`:16`). Nunca un enlace a un sitio que en ese entorno no existe.
 *
 * La env se lee con `getEnv` (runtime, `window.__ENV__`) y no con
 * `import.meta.env`: la imagen del portal es única para todos los entornos y
 * lo horneado en build llega vacío a la nube.
 *
 * La base puede venir con barra final (`https://comunidad.tecopos.com/`) o sin
 * ella: se normaliza para no componer `//trivia`.
 */
export function urlDeLaTrivia(): string | undefined {
  const base = getEnv('VITE_COMUNIDAD_URL')?.trim()
  if (!base) return undefined
  return `${base.replace(/\/+$/, '')}${RUTA_TRIVIA}`
}
